import React from "react";

export const Card = ({ children, className }) => (
  <div className={`rounded-2xl shadow-lg bg-white border border-gray-200 ${className || ""}`}>
    {children}
  </div>
);

export const CardHeader = ({ children, className }) => (
  <div className={`px-4 py-3 border-b rounded-t-2xl bg-gradient-to-r from-indigo-500 to-purple-500 text-white ${className || ""}`}>
    {children}
  </div>
);

export const CardTitle = ({ children, className }) => (
  <h2 className={`text-xl font-semibold ${className || ""}`} style={{"color":"black"}}>
    {children}
  </h2>
);

export const CardContent = ({ children, className }) => (
  <div className={`p-4 ${className || ""}`}>
    {children}
  </div>
);
